import { render, staticRenderFns } from "./PortfolioDetail.vue?vue&type=template&id=6437f41e&scoped=true&"
import script from "./PortfolioDetail.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetail.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDetail.vue?vue&type=style&index=0&id=6437f41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437f41e",
  null
  
)

export default component.exports